import React from 'react';

function fmt(value, digits = 1, suffix = '') {
  if (value == null || value === '') return '—';
  const number = Number(value);
  return Number.isFinite(number) ? `${number.toFixed(digits)}${suffix}` : '—';
}

const ACTION_LABELS = { buy: '买入', add: '加仓', hold: '持有', reduce: '减仓' };

export default function DrawdownPathPanel({ analysis }) {
  if (!analysis) return null;
  if (!analysis.available) return <p className="decision-muted">{analysis.summary}</p>;
  const current = analysis.current_episode;
  return (
    <div className={`drawdown-path-panel state-${analysis.state?.key || 'unknown'}`}>
      <div className="drawdown-path-head">
        <div><span>DRAWDOWN PATH · 回撤路径</span><strong>{analysis.state?.label}</strong><p>{analysis.summary}</p></div>
        <div className="drawdown-window-meta"><span>全部已有记录</span><strong>{analysis.source_points}个净值点</strong><small>{analysis.start_date} 至 {analysis.end_date}</small></div>
      </div>
      <div className="drawdown-path-kpis">
        <div><span>当前回撤</span><strong>{fmt(current?.current_drawdown_bp, 1, 'bp')}</strong><small>{current ? `相对${current.peak_date}高点` : '当前已回到窗口前高'}</small></div>
        <div><span>本轮最深回撤</span><strong>{fmt(current?.max_drawdown_bp ?? analysis.max_drawdown_bp, 1, 'bp')}</strong><small>{current?.trough_date || '近30点最大回撤'}</small></div>
        <div><span>谷底后修复</span><strong>{fmt(current?.repair_pct, 1, '%')}</strong><small>{current ? `距谷底${current.days_since_trough}个净值点` : '当前无未修复回撤'}</small></div>
        <div><span>全历史回撤次数</span><strong>{analysis.episode_count}</strong><small>已修复{analysis.recovered_count}次 · 平均{fmt(analysis.average_recovery_days, 1, '点')}</small></div>
      </div>
      <div className="drawdown-window-grid">
        {(analysis.windows || []).map((item) => <div key={item.key} className={!item.available ? 'is-missing' : ''}>
          <span>{item.label}</span>
          {item.available ? <><strong>最大 {fmt(item.max_drawdown_bp, 1, 'bp')}</strong><em>当前 {fmt(item.current_drawdown_bp, 1, 'bp')}</em><small>{item.episode_count}次回撤 · {item.recovered_count}次修复</small></> : <strong>{item.reason}</strong>}
        </div>)}
      </div>
      {analysis.recent_episodes?.length ? <details className="drawdown-episode-details">
        <summary>查看最近回撤过程（{analysis.recent_episodes.length}次）</summary>
        <div className="drawdown-episode-table-wrap"><table><thead><tr><th>前高</th><th>谷底</th><th>最深回撤</th><th>修复日</th><th>修复用时</th><th>状态</th></tr></thead>
          <tbody>{analysis.recent_episodes.map((item, index) => <tr key={`${item.peak_date}-${item.trough_date}-${index}`}><td>{item.peak_date}</td><td>{item.trough_date}</td><td>{fmt(item.max_drawdown_bp, 1, 'bp')}</td><td>{item.recovery_date || '—'}</td><td>{item.recovered ? `${item.recovery_days}个净值点` : '尚未修复'}</td><td>{item.recovered ? '已修复' : `已修复${fmt(item.repair_pct, 1, '%')}`}</td></tr>)}</tbody>
        </table></div>
      </details> : null}
      {analysis.action_use?.repeat_note || analysis.action_use?.current_note ? <p className="drawdown-path-note">{[analysis.action_use.repeat_note, analysis.action_use.current_note].filter(Boolean).join('；')}</p> : null}
      {analysis.anomaly_caution ? <p className="drawdown-path-caution">{analysis.anomaly_caution}</p> : null}
      <div className="drawdown-path-actions">{Object.entries(ACTION_LABELS).map(([key, label]) => <div key={key}><span>{label}</span><p>{analysis.action_use?.[key]}</p></div>)}</div>
      <p className="drawdown-path-method">{analysis.method}</p>
    </div>
  );
}
